export type Lang = 'en' | 'es'

export const translations = {
  // Header
  'header.cta': { en: 'Check My Options', es: 'Ver Mis Opciones' },

  // Hero
  'hero.headline1': { en: 'The Boss Gets', es: 'El Boss Te' },
  'hero.headline2': { en: 'You Approved', es: 'Aprueba' },
  'hero.sub': {
    en: '$0 down. All credit welcome. 20+ lenders. One call to Mitchell.',
    es: '$0 inicial. Todo crédito. 20+ bancos. Una llamada a Mitchell.',
  },
  'hero.bullet1': { en: 'All credit welcome', es: 'Todo crédito bienvenido' },
  'hero.bullet2': { en: '$0 down options', es: 'Opciones $0 inicial' },
  'hero.bullet3': { en: 'Trade-ins welcome', es: 'Trade-ins aceptados' },
  'hero.cta1': { en: 'Check My Options', es: 'Ver Mis Opciones' },
  'hero.cta2': { en: 'WhatsApp Us', es: 'WhatsApp' },
  'hero.scroll': { en: 'Scroll', es: 'Scroll' },

  // Trust Bar
  'trust.1.title': { en: 'Approved in 24h', es: 'Aprobado en 24h' },
  'trust.1.desc': {
    en: '$0 down available. 20+ lenders competing for you.',
    es: '$0 inicial disponible. 20+ bancos compitiendo por ti.',
  },
  'trust.2.title': { en: 'Best Trade-In Value', es: 'Mejor Valor Trade-In' },
  'trust.2.desc': {
    en: 'We beat other offers. Applied same day.',
    es: 'Superamos otras ofertas. Aplicado el mismo día.',
  },
  'trust.3.title': { en: '500+ Clients Helped', es: '500+ Clientes Ayudados' },
  'trust.3.desc': {
    en: 'Miami & South Florida. EN / ES.',
    es: 'Miami y South Florida. EN / ES.',
  },

  // Comparison
  'comp.title': { en: 'The', es: 'La' },
  'comp.name': { en: 'Mitchell', es: 'Mitchell' },
  'comp.titleEnd': { en: ' Difference', es: ' Diferencia' },
  'comp.sub': {
    en: 'Real numbers. Real approvals. Real results.',
    es: 'Números reales. Aprobaciones reales. Resultados reales.',
  },
  'comp.bad.title': { en: 'Other Dealers', es: 'Otros Dealers' },
  'comp.bad.1': {
    en: '3-5 day approval wait',
    es: '3-5 días esperando aprobación',
  },
  'comp.bad.2': {
    en: 'Hidden fees & surprises',
    es: 'Cargos ocultos y sorpresas',
  },
  'comp.bad.3': {
    en: 'One bank, one option',
    es: 'Un banco, una opción',
  },
  'comp.bad.4': { en: '4+ hours at the dealer', es: '4+ horas en el dealer' },
  'comp.bad.5': {
    en: 'Low-ball trade-in offers',
    es: 'Ofertas bajas por tu trade-in',
  },
  'comp.good.title': { en: 'Mitchellthekiaboss', es: 'Mitchellthekiaboss' },
  'comp.good.1': {
    en: 'Approved in 24h or less',
    es: 'Aprobado en 24h o menos',
  },
  'comp.good.2': {
    en: 'Price you see = price you pay',
    es: 'El precio que ves = el que pagas',
  },
  'comp.good.3': {
    en: '20+ lenders competing for you',
    es: '20+ bancos compitiendo por ti',
  },
  'comp.good.4': {
    en: 'Done over WhatsApp, your pace',
    es: 'Todo por WhatsApp, a tu ritmo',
  },
  'comp.good.5': {
    en: 'Best trade-in value, guaranteed',
    es: 'Mejor valor trade-in, garantizado',
  },
  'comp.recommended': { en: 'Recommended', es: 'Recomendado' },
  'comp.cta': { en: 'Check My Options', es: 'Ver Mis Opciones' },

  // How It Works
  'how.title': { en: 'Three Steps', es: 'Tres Pasos' },
  'how.1.title': { en: 'Tell Us', es: 'Cuéntanos' },
  'how.1.desc': {
    en: 'What you want, your budget, your situation. 60 seconds.',
    es: 'Qué buscas, tu presupuesto, tu situación. 60 segundos.',
  },
  'how.2.title': { en: 'We Match', es: 'Buscamos' },
  'how.2.desc': {
    en: 'Inventory + lenders. Best fit for you.',
    es: 'Inventario + bancos. Lo mejor para ti.',
  },
  'how.3.title': { en: 'You Drive', es: 'Manejas' },
  'how.3.desc': {
    en: 'Sign and go. Often the same week.',
    es: 'Firma y listo. Muchas veces la misma semana.',
  },

  // Social Proof
  'social.title': { en: 'Real Results', es: 'Resultados Reales' },
  'social.sub': {
    en: 'Join 500+ happy drivers in South Florida.',
    es: 'Únete a 500+ conductores felices en South Florida.',
  },
  'social.rating': { en: '4.9 on Google', es: '4.9 en Google' },
  'social.reviews': { en: '150+ reviews', es: '150+ reseñas' },
  'social.1.quote': {
    en: 'Approved in 2 days with a 580 score. Drove off in a 2023 Tucson. $289/mo. No games.',
    es: 'Aprobado en 2 días con score de 580. Salí en un Tucson 2023. $289/mes. Sin juegos.',
  },
  'social.1.author': { en: 'Marcus T.', es: 'Marcus T.' },
  'social.1.detail': { en: '2023 Hyundai Tucson', es: '2023 Hyundai Tucson' },
  'social.2.quote': {
    en: 'Traded my 2018 Civic, got $3K more than CarMax offered. Left in a Terrain the same week.',
    es: 'Hice trade-in de mi Civic 2018, me dieron $3K más que CarMax. Salí en un Terrain la misma semana.',
  },
  'social.2.author': { en: 'Jennifer R.', es: 'Jennifer R.' },
  'social.2.detail': { en: '2024 GMC Terrain', es: '2024 GMC Terrain' },
  'social.3.quote': {
    en: 'First-time buyer, no credit history. Mitchell got me approved with $0 down. Unreal.',
    es: 'Primera vez comprando, sin historial. Mitchell me aprobó con $0 inicial. Increíble.',
  },
  'social.3.author': { en: 'David L.', es: 'David L.' },
  'social.3.detail': { en: '2023 Nissan Kicks', es: '2023 Nissan Kicks' },
  'social.role': { en: 'Verified Buyer', es: 'Comprador Verificado' },

  // Lead Form
  'form.title1': { en: 'Check Your', es: 'Revisa Tus' },
  'form.title2': { en: 'Options', es: 'Opciones' },
  'form.title3': { en: 'Now', es: 'Ahora' },
  'form.sub': {
    en: '60 seconds. No commitment. Real numbers in 24h.',
    es: '60 segundos. Sin compromiso. Números reales en 24h.',
  },
  'form.name': { en: 'Full Name', es: 'Nombre' },
  'form.name.placeholder': { en: 'John Smith', es: 'Juan Pérez' },
  'form.phone': { en: 'Phone', es: 'Teléfono' },
  'form.email': { en: 'Email', es: 'Email' },
  'form.email.placeholder': { en: 'john@example.com', es: 'juan@ejemplo.com' },
  'form.vehicle': { en: 'Vehicle Type', es: 'Tipo de Vehículo' },
  'form.vehicle.suv': { en: 'SUV', es: 'SUV' },
  'form.vehicle.sedan': { en: 'Sedan', es: 'Sedán' },
  'form.vehicle.truck': { en: 'Truck', es: 'Camioneta' },
  'form.vehicle.coupe': { en: 'Coupe / Sports', es: 'Coupé / Deportivo' },
  'form.vehicle.minivan': { en: 'Minivan', es: 'Minivan' },
  'form.vehicle.other': { en: 'Other', es: 'Otro' },
  'form.credit': { en: 'Credit', es: 'Crédito' },
  'form.credit.excellent': { en: 'Excellent (720+)', es: 'Excelente (720+)' },
  'form.credit.good': { en: 'Good (660-719)', es: 'Bueno (660-719)' },
  'form.credit.fair': { en: 'Fair (600-659)', es: 'Regular (600-659)' },
  'form.credit.rebuilding': {
    en: 'Rebuilding (<600)',
    es: 'Reconstruyendo (<600)',
  },
  'form.credit.first': { en: 'First-time buyer', es: 'Primera vez' },
  'form.credit.unsure': { en: 'Not sure', es: 'No estoy seguro' },
  'form.submit': { en: 'Check My Options', es: 'Ver Mis Opciones' },
  'form.processing': { en: 'Processing...', es: 'Procesando...' },
  'form.secure': {
    en: 'Your info is secure. No spam, ever.',
    es: 'Tu info está segura. Cero spam.',
  },

  // Form States
  'form.dup.title': { en: 'Request Received', es: 'Solicitud Recibida' },
  'form.dup.text': {
    en: 'We have your info. Need faster help?',
    es: 'Ya tenemos tus datos. ¿Necesitas ayuda rápida?',
  },
  'form.dup.cta': { en: 'Chat on WhatsApp', es: 'Ir a WhatsApp' },
  'form.success.title': { en: '🎉 Excellent,', es: '🎉 ¡Excelente,' },
  'form.success.titleEnd': { en: '!', es: '!' },
  'form.success.subtitle': {
    en: 'Your request was received',
    es: 'Tu solicitud fue recibida',
  },
  'form.success.redirect': {
    en: 'Opening WhatsApp in',
    es: 'Abriendo WhatsApp en',
  },
  'form.success.seconds': { en: 'sec', es: 'seg' },
  'form.success.cta': {
    en: '💬 Chat with Mitchell now',
    es: '💬 Chatear con Mitchell ahora',
  },
  'form.success.fallback': {
    en: "WhatsApp didn't open?",
    es: '¿No se abrió WhatsApp?',
  },
  'form.success.fallbackLink': {
    en: '👉 Click here to open WhatsApp',
    es: '👉 Haz clic aquí para abrir WhatsApp',
  },

  // WhatsApp Messages
  'wa.hero': {
    en: "Hi Mitchell, I saw your page and I'm interested in a vehicle",
    es: 'Hola Mitchell, vi tu página y me interesa un vehículo',
  },
  'wa.form': {
    en: "Hi Mitchell, I just submitted my info. I'm {name}, interested in a {vehicle}.",
    es: 'Hola Mitchell, acabo de enviar mi info. Soy {name}, me interesa un {vehicle}.',
  },

  // Final CTA
  'final.title': {
    en: 'Your Next Car Is Closer Than You Think',
    es: 'Tu Próximo Carro Está Más Cerca De Lo Que Crees',
  },
  'final.sub': {
    en: '60 seconds. No commitment. Approval solutions for every situation.',
    es: '60 segundos. Sin compromiso. Soluciones para cada situación.',
  },
  'final.cta': { en: 'Check My Options', es: 'Ver Mis Opciones' },
  'final.wa': { en: 'Message on WhatsApp →', es: 'Mensaje por WhatsApp →' },

  // Sticky CTA
  'sticky.cta': { en: 'See Options', es: 'Ver Opciones' },

  // Urgency Timer
  'urgency.title': {
    en: '🔥 Limited-Time Offer',
    es: '🔥 Oferta Por Tiempo Limitado',
  },
  'urgency.text': {
    en: "This week's pre-approval window closes in",
    es: 'La ventana de pre-aprobación de esta semana cierra en',
  },
  'urgency.hours': { en: 'hrs', es: 'hrs' },
  'urgency.minutes': { en: 'min', es: 'min' },
  'urgency.seconds': { en: 'sec', es: 'seg' },

  // Footer
  'footer.rights': {
    en: 'All rights reserved.',
    es: 'Todos los derechos reservados.',
  },
  'footer.serving': {
    en: 'Miami & South Florida — Hablamos español',
    es: 'Miami y South Florida — We speak English',
  },
  'footer.address': {
    en: 'Miami, FL — By appointment',
    es: 'Miami, FL — Con cita previa',
  },
  'footer.hours': {
    en: 'Mon–Sat 9AM–7PM',
    es: 'Lun–Sáb 9AM–7PM',
  },
  'footer.phone': {
    en: '(555) 866-2436',
    es: '(555) 866-2436',
  },
} as const

export type TranslationKey = keyof typeof translations

export type Lang = 'en' | 'es'
